/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FraudBlockPlayerRequest
 */
export interface FraudBlockPlayerRequest {
    /**
     * 
     * @type {string}
     * @memberof FraudBlockPlayerRequest
     */
    note: string;
}

/**
 * Check if a given object implements the FraudBlockPlayerRequest interface.
 */
export function instanceOfFraudBlockPlayerRequest(value: object): value is FraudBlockPlayerRequest {
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function FraudBlockPlayerRequestFromJSON(json: any): FraudBlockPlayerRequest {
    return FraudBlockPlayerRequestFromJSONTyped(json, false);
}

export function FraudBlockPlayerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FraudBlockPlayerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function FraudBlockPlayerRequestToJSON(value?: FraudBlockPlayerRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'note': value['note'],
    };
}

